export default __webpack_public_path__ + "static/media/team.936a41fb.jpg";